import moment from 'moment'
import React from 'react'

import { Trends } from '../domain/history/Trends'
import BoxBody from '../helper/boxBody'
import LargeNumber from '../helper/large-number'
import Memory from '../helper/memory'
import Milliseconds from '../helper/milliseconds'
import Percent from '../helper/percent'
import Sparkline from '../helper/sparkline'
import Tendency from '../helper/tendency'
import { layersDownstreamLayers, layersNameToClass, layersNameToLabel } from '../domain/Layers'

interface Props {
    data: { trends: Trends }
    loading: boolean
}

class TrendsComponent extends React.Component<Props> {
    public static defaultProps = {
        loading: false,
    }

    public completeTrendRow = (dateRangeTrends, key) =>
        Array(5 - dateRangeTrends.length).map((element, index) => <td key={key + '-' + index} />)

    public render = () => (
        <BoxBody {...this.props} className="no-padding">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ width: '10%' }} />
                        {this.completeTrendRow(this.props.data.trends.dateRangeTrends, 'date')}
                        {this.props.data.trends.dateRangeTrends.map(trend => (
                            <th key={trend.range.startDate} className="number">
                                {moment(trend.range.startDate).format('D.M.Y') !== moment(trend.range.endDate).format('D.M.Y')
                                    ? moment(trend.range.startDate).format('D.M.') + ' - ' + moment(trend.range.endDate).format('D.M.Y')
                                    : moment(trend.range.startDate).format('D.M.Y')}
                            </th>
                        ))}
                        <th style={{ width: '20%' }} />
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>Requests</th>

                        {this.completeTrendRow(this.props.data.trends.dateRangeTrends, 'requests')}

                        {this.props.data.trends.dateRangeTrends.map((trend, index) => (
                            <td key={trend.range.startDate} className="number">
                                <LargeNumber value={trend.requests} />{' '}
                                {index - 1 in this.props.data.trends.dateRangeTrends ? (
                                    <Tendency
                                        value={
                                            (trend.requests - this.props.data.trends.dateRangeTrends[index - 1].requests) /
                                            this.props.data.trends.dateRangeTrends[index - 1].requests
                                        }
                                        showValue={false}
                                        lessIsGood={false}
                                    />
                                ) : null}
                            </td>
                        ))}
                        <td>
                            <Sparkline
                                data={this.props.data.trends.dateRangeTrends.map(trend => ({
                                    start: new Date(trend.range.startDate),
                                    end: new Date(trend.range.endDate),
                                    value: trend.requests,
                                }))}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>
                            Response Time
                            <br />
                            <small>(95% Percentile)</small>
                        </th>

                        {this.completeTrendRow(this.props.data.trends.dateRangeTrends, 'response')}

                        {this.props.data.trends.dateRangeTrends.map((trend, index) => (
                            <td key={trend.range.startDate} className="number">
                                <Milliseconds value={trend.responseTime * 1000} />{' '}
                                {index - 1 in this.props.data.trends.dateRangeTrends ? (
                                    <Tendency
                                        value={
                                            (trend.responseTime - this.props.data.trends.dateRangeTrends[index - 1].responseTime) /
                                            this.props.data.trends.dateRangeTrends[index - 1].responseTime
                                        }
                                        showValue={false}
                                    />
                                ) : null}
                            </td>
                        ))}
                        <td>
                            <Sparkline
                                data={this.props.data.trends.dateRangeTrends.map(trend => ({
                                    start: new Date(trend.range.startDate),
                                    end: new Date(trend.range.endDate),
                                    value: trend.responseTime / 1000,
                                }))}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>Max Memory</th>

                        {this.completeTrendRow(this.props.data.trends.dateRangeTrends, 'maxMemory')}
                        {this.props.data.trends.dateRangeTrends.map((trend, index) => (
                            <td key={trend.range.startDate} className="number">
                                <Memory value={trend.maxMemory * 1024} />{' '}
                                {index - 1 in this.props.data.trends.dateRangeTrends ? (
                                    <Tendency
                                        value={
                                            (trend.maxMemory - this.props.data.trends.dateRangeTrends[index - 1].maxMemory) /
                                            this.props.data.trends.dateRangeTrends[index - 1].maxMemory
                                        }
                                        showValue={false}
                                    />
                                ) : null}
                            </td>
                        ))}
                        <td>
                            <Sparkline
                                data={this.props.data.trends.dateRangeTrends.map(trend => ({
                                    start: new Date(trend.range.startDate),
                                    end: new Date(trend.range.endDate),
                                    value: trend.maxMemory / 1024,
                                }))}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>Failures</th>

                        {this.completeTrendRow(this.props.data.trends.dateRangeTrends, 'error')}

                        {this.props.data.trends.dateRangeTrends.map((trend, index) => (
                            <td key={trend.range.startDate} className="number">
                                <Percent value={trend.errorRate / 100} />{' '}
                                {index - 1 in this.props.data.trends.dateRangeTrends ? (
                                    <Tendency
                                        value={
                                            (trend.errorRate - this.props.data.trends.dateRangeTrends[index - 1].errorRate) /
                                            this.props.data.trends.dateRangeTrends[index - 1].errorRate
                                        }
                                        showValue={false}
                                    />
                                ) : null}
                            </td>
                        ))}
                        <td>
                            <Sparkline
                                data={this.props.data.trends.dateRangeTrends.map(trend => ({
                                    start: new Date(trend.range.startDate),
                                    end: new Date(trend.range.endDate),
                                    value: trend.errorRate,
                                }))}
                            />
                        </td>
                    </tr>
                    {this.renderPageCacheRow()}
                    {this.renderCrawlerRow()}
                    {layersDownstreamLayers().map(layer => this.renderResponseRow(layer))}
                </tbody>
            </table>
        </BoxBody>
    )

    private renderCrawlerRow = () => {
        if (
            this.props.data.trends.dateRangeTrends.reduce((previousValue, currentValue) => previousValue + currentValue.crawlers, 0) === 0
        ) {
            return null
        }

        return (
            <tr>
                <th>Crawlers</th>

                {this.completeTrendRow(this.props.data.trends.dateRangeTrends, 'crawlers')}

                {this.props.data.trends.dateRangeTrends.map((trend, index) => (
                    <td key={trend.range.startDate} className="number">
                        <Percent value={trend.crawlers / trend.requests} />{' '}
                    </td>
                ))}
                <td>
                    <Sparkline
                        data={this.props.data.trends.dateRangeTrends.map(trend => ({
                            start: new Date(trend.range.startDate),
                            end: new Date(trend.range.endDate),
                            value: (trend.crawlers / trend.requests) * 100,
                        }))}
                    />
                </td>
            </tr>
        )
    }

    private renderPageCacheRow = () => {
        if (
            this.props.data.trends.dateRangeTrends.reduce(
                (previousValue, currentValue) => previousValue + (currentValue.pageCache.hits + currentValue.pageCache.misses),
                0,
            ) === 0
        ) {
            return null
        }

        return (
            <tr>
                <th>Page Cache Hit Rate</th>

                {this.completeTrendRow(this.props.data.trends.dateRangeTrends, 'pageCache')}

                {this.props.data.trends.dateRangeTrends.map((trend, index) => (
                    <td key={trend.range.startDate} className="number">
                        <Percent value={trend.pageCache.hits / (trend.pageCache.hits + trend.pageCache.misses)} />{' '}
                    </td>
                ))}
                <td>
                    <Sparkline
                        data={this.props.data.trends.dateRangeTrends.map(trend => ({
                            start: new Date(trend.range.startDate),
                            end: new Date(trend.range.endDate),
                            value: (trend.pageCache.hits / (trend.pageCache.hits + trend.pageCache.misses)) * 100,
                        }))}
                    />
                </td>
            </tr>
        )
    }

    private renderResponseRow = (layer: string) => {
        const totalValues = this.props.data.trends.dateRangeTrends.reduce((previousValue, currentValue) => {
            return previousValue + (currentValue[layer] || 0)
        }, 0)

        if (totalValues === 0) {
            return null
        }

        return (
            <tr>
                <th>
                    <i className={'icon fa fa-square ' + layersNameToClass(layer)} /> {layersNameToLabel(layer)}
                </th>

                {this.completeTrendRow(this.props.data.trends.dateRangeTrends, layer)}

                {this.props.data.trends.dateRangeTrends.map((trend, index) => (
                    <td key={trend.range.startDate} className="number">
                        <Milliseconds value={trend[layer] * 1000} />{' '}
                        {index - 1 in this.props.data.trends.dateRangeTrends ? (
                            <Tendency
                                value={
                                    (trend[layer] - this.props.data.trends.dateRangeTrends[index - 1][layer]) /
                                    this.props.data.trends.dateRangeTrends[index - 1][layer]
                                }
                                showValue={false}
                            />
                        ) : null}
                    </td>
                ))}
                <td>
                    <Sparkline
                        data={this.props.data.trends.dateRangeTrends.map(trend => ({
                            start: new Date(trend.range.startDate),
                            end: new Date(trend.range.endDate),
                            value: trend[layer] / 1000,
                        }))}
                    />
                </td>
            </tr>
        )
    }
}

export default TrendsComponent
